
import React from "react";
import DreamItem from "./DreamItem";
import { Dream } from "@/types/database-extensions";

interface DreamsGridProps {
  dreams: Dream[];
  onDelete: (id: string) => void;
  updateKarmaPoints: (points: number) => Promise<void>;
}

const DreamsGrid: React.FC<DreamsGridProps> = ({ dreams, onDelete, updateKarmaPoints }) => {
  if (dreams.length === 0) {
    return (
      <div className="col-span-2 p-8 text-center text-muted-foreground">
        Add your first dream to get started!
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {dreams.map((dream) => (
        <DreamItem 
          key={dream.id} 
          dream={dream} 
          onDelete={onDelete} 
          updateKarmaPoints={updateKarmaPoints}
        />
      ))}
    </div>
  );
};

export default DreamsGrid;
